import Vue from 'vue'
import Search from '@/components/Search.vue'

Vue.config.productionTip = false

Vue.prototype.$baseURL = process.env.VUE_APP_ROOT_URL

new Vue({
  render: h => h(Search),
}).$mount('#yze-search')
